module.exports = __webpack_public_path__ + "static/img/indexbg12.20a914a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg12.jpg
// module id = LP3g
// module chunks = 1